import React from "react";

const TOPBAR_ICON_SIZE = 20;

function svgProps(props) {
	const { className, style, ...rest } = props;
	const hasExplicitSize =
		style?.width != null ||
		style?.height != null ||
		(className && /\bsize-|\bw-|\bh-/.test(className));

	return {
		...rest,
		className: [
			!hasExplicitSize && "block h-full w-full max-h-full max-w-full",
			className,
		]
			.filter(Boolean)
			.join(" "),
		style,
	};
}

export function topbarIconProps(props = {}) {
	return {
		...props,
		style: {
			width: TOPBAR_ICON_SIZE,
			height: TOPBAR_ICON_SIZE,
			...props.style,
		},
	};
}

export function IconMenu(props) {
	return (
		<svg {...svgProps(props)} viewBox="0 0 24 24" fill="currentColor">
			<path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z" />
		</svg>
	);
}

export function IconSettings(props) {
	return (
		<svg
			{...svgProps(props)}
			viewBox="0 0 24 24"
			fill="none"
			stroke="currentColor"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		>
			<path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z" />
			<circle cx="12" cy="12" r="3" />
		</svg>
	);
}

/* Dashboard — LuMonitorDot (Tailwick: Dashboards) */
export function IconDashboard(props) {
	return (
		<svg {...svgProps(props)} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
			<path d="M12 17v4" />
			<path d="M22 12.307V15a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h8.693" />
			<path d="M8 21h8" />
			<circle cx="19" cy="6" r="3" />
		</svg>
	);
}

/* Conversas — LuMessagesSquare (Tailwick: Chat) */
export function IconWhatsApp(props) {
	return (
		<svg {...svgProps(props)} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
			<path d="M16 10a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 14.286V4a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z" />
			<path d="M20 9a2 2 0 0 1 2 2v10.286a.71.71 0 0 1-1.212.502l-2.202-2.202A2 2 0 0 0 17.172 19H10a2 2 0 0 1-2-2v-1" />
		</svg>
	);
}

/* Contatos — LuSquareUserRound (Tailwick: Users) */
export function IconContacts(props) {
	return (
		<svg {...svgProps(props)} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
			<path d="M18 21a6 6 0 0 0-12 0" />
			<circle cx="12" cy="11" r="4" />
			<rect x="3" y="3" width="18" height="18" rx="2" />
		</svg>
	);
}

/* Respostas rápidas — LuClipboardList (Tailwick: Notes) */
export function IconQuickAnswers(props) {
	return (
		<svg {...svgProps(props)} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
			<rect x="8" y="2" width="8" height="4" rx="1" ry="1" />
			<path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" />
			<path d="M12 11h4" />
			<path d="M12 16h4" />
			<path d="M8 11h.01" />
			<path d="M8 16h.01" />
		</svg>
	);
}

export function IconDocumentation(props) {
	return (
		<svg {...svgProps(props)} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
			<path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
			<path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
		</svg>
	);
}

/* Envio em massa — LuShare2 (Tailwick: Multi Level / compartilhar) */
export function IconBulkMessaging(props) {
	return (
		<svg {...svgProps(props)} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
			<circle cx="18" cy="5" r="3" />
			<circle cx="6" cy="12" r="3" />
			<circle cx="18" cy="19" r="3" />
			<path d="m8.59 13.51 6.83 3.98" />
			<path d="m15.41 6.51-6.82 3.98" />
		</svg>
	);
}

export const IconTelegram = IconBulkMessaging;

/* Agendamentos — LuCalendar1 (Tailwick: Calendar) */
export function IconSchedule(props) {
	return (
		<svg {...svgProps(props)} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
			<path d="M11 14h1v4" />
			<path d="M16 2v4" />
			<path d="M3 10h18" />
			<path d="M8 2v4" />
			<rect x="3" y="4" width="18" height="18" rx="2" />
		</svg>
	);
}

/* Google Agenda — calendar with check */
export function IconGoogleAgenda(props) {
	return (
		<svg {...svgProps(props)} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
			<path d="M8 2v4" />
			<path d="M16 2v4" />
			<rect x="3" y="4" width="18" height="18" rx="2" />
			<path d="M3 10h18" />
			<path d="m9 16 2 2 4-4" />
		</svg>
	);
}

/* Etiquetas — Lucide Tag */
export function IconTags(props) {
	return (
		<svg {...svgProps(props)} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
			<path d="M12.586 2.586A2 2 0 0 0 11.172 2H4a2 2 0 0 0-2 2v7.172a2 2 0 0 0 .586 1.414l8.704 8.704a2.426 2.426 0 0 0 3.42 0l6.58-6.58a2.426 2.426 0 0 0 0-3.42z" />
			<circle cx="7.5" cy="7.5" r=".5" fill="currentColor" />
		</svg>
	);
}

/* Painel Master – building-office (Heroicons outline) */
export function IconSecurity(props) {
	return (
		<svg {...svgProps(props)} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
			<path d="M3.75 21H20.25M4.5 3H19.5M5.25 3V21M18.75 3V21M9 6.75H10.5M9 9.75H10.5M9 12.75H10.5M13.5 6.75H15M13.5 9.75H15M13.5 12.75H15M9 21V17.625C9 17.0037 9.50368 16.5 10.125 16.5H13.875C14.4963 16.5 15 17.0037 15 17.625V21" />
		</svg>
	);
}

/* Lua: modo escuro ativo (mostra lua para indicar "está em dark") */
export function IconBrightness4(props) {
	return (
		<svg {...svgProps(props)} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
			<path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
		</svg>
	);
}

/* Sol: modo claro ativo (mostra sol para indicar "está em light") */
export function IconBrightness7(props) {
	return (
		<svg {...svgProps(props)} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
			<circle cx="12" cy="12" r="4" />
			<path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M6.34 17.66l-1.41 1.41M19.07 4.93l-1.41 1.41" />
		</svg>
	);
}

export function IconAccount(props) {
	return (
		<svg {...svgProps(topbarIconProps(props))} viewBox="0 0 24 24" fill="currentColor">
			<path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
		</svg>
	);
}

export function IconTranslate(props) {
	return (
		<svg {...svgProps(props)} viewBox="0 0 24 24" fill="currentColor">
			<path d="M12.87 15.07l-2.54-2.51.03-.03A17.52 17.52 0 0014.07 6H17V4h-7V2H8v2H1v2h11.17C11.5 7.92 10.44 9.75 9 11.35 8.07 10.32 7.3 9.19 6.69 8h-2c.73 1.63 1.73 3.17 2.98 4.56l-5.09 5.02L4 19l5-5 3.11 3.11.76-2.04zM18.5 10h-2L12 22h2l1.12-3h4.75L21 22h2l-4.5-12zm-2.62 7l1.62-4.33L19.12 17h-3.24z" />
		</svg>
	);
}

export function IconChevronDown(props) {
	return (
		<svg {...svgProps(props)} viewBox="0 0 24 24" fill="currentColor">
			<path d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z" />
		</svg>
	);
}

export function IconStatusDot({ color, size: s = 10, ...props }) {
	return (
		<span
			{...props}
			style={{
				width: s,
				height: s,
				borderRadius: "50%",
				backgroundColor: color,
				position: "absolute",
				bottom: 0,
				right: 0,
			}}
		/>
	);
}

export function IconSalesFunnel(props) {
	return (
		<svg className="size-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
			<path d="M4 5h16" />
			<path d="M7 12h10" />
			<path d="M10 19h4" />
		</svg>
	);
}

/* Comentários sociais — balão com linhas (feed / comentários em posts) */
export function IconSocialComments(props) {
	return (
		<svg
			{...svgProps(props)}
			viewBox="0 0 24 24"
			fill="none"
			stroke="currentColor"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		>
			<path d="M7.9 20A9 9 0 1 0 4 16.1L2 22Z" />
			<path d="M8 12h.01" />
			<path d="M12 12h.01" />
			<path d="M16 12h.01" />
		</svg>
	);
}

/* Assistente geral — sparkles (cara de IA) */
export function IconAssistant(props) {
	return (
		<svg
			{...svgProps(props)}
			viewBox="0 0 24 24"
			fill="none"
			stroke="currentColor"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		>
			<path d="M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z" />
			<path d="M20 3v4" />
			<path d="M22 5h-4" />
			<path d="M4 17v2" />
			<path d="M5 18H3" />
		</svg>
	);
}
